import React, { useRef } from 'react';

import { ModuleDispatcher } from '$partials/modules';
import { Header } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ArtistDetailPage}
 */
const ArtistDetailPage = (props) => {
    const page = props.data.page;
    const bodyRef = useRef();
    return (
        <>
            <Header
                {...props.data?.header}
                bodyRef={bodyRef}
                domain={props.domain}/>
            <main id='main-content'>
                <div className='px-layout-outer pt-[50px] sm:pt-[100px] pb-32 sticky top-0 bg-white z-10'>
                    <div className='-mx-layout-col flex'>
                        <div className='px-layout-col w-full sm:w-2/7 gap-y-16 grid auto-rows-min'>
                            <h1>
                                {page.title}{page.role && `, ${page.role}`}
                            </h1>
                            <div
                                className='rich-text max-w-[400px]'
                                dangerouslySetInnerHTML={{ __html: page.standfirst }} />
                        </div>
                    </div>
                </div>
                {page?.works?.length > 0 && (
                    <section
                        className='bg-[white] z-10 relative'
                        ref={bodyRef}>
                        {page.works.map((module, i) => (
                            <ModuleDispatcher
                                {...module}
                                displayTitle={true}
                                key={i + module?.id}/>
                        ))}
                    </section>
                )}
            </main>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default ArtistDetailPage;
